(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

// Function to dynamically add price and labels
const checkAndAddPriceBefore = () => {
  const labels = document.querySelectorAll('.rc-radio.onetime-radio .rc-radio__label');

  if (labels.length > 0) {
    labels.forEach((label) => {
      // Ensure the ::before content isn't already added
      if (!label.classList.contains('price-added')) {
        const text = label.textContent.trim();
        const priceMatch = text.match(/\$\s*\d+(\.\d{2})?/);

        if (priceMatch) {
          const price = priceMatch[0];

          // Add a class to mark the label as processed
          label.classList.add('price-added');

          // Set custom properties (CSS variables) to store the price
          label.style.setProperty('--price', `'${price}'`);
          label.style.setProperty('--description', `'One-time purchase'`);

          // Dynamically add CSS for the pseudo-elements
          const style = document.createElement('style');
          style.textContent = `
            .rc-radio.onetime-radio .rc-radio__label.price-added::before {
              content: var(--price);
              font-weight: bold;
              margin-right: 17px;
            }
            .rc-radio.onetime-radio .rc-radio__label.price-added::after {
              content: var(--description);
              font-weight: bold;
            }
          `;
          document.head.appendChild(style);
        }
      }
    });

    // Stop the interval once the labels are processed
    clearInterval(intervalId);
  }
};

// Function to update the priceMatch dynamically
const updateLabelPrice = () => {

  const clicklabels = document.querySelectorAll('.rc-radio.onetime-radio .rc-radio__label');
  if (clicklabels.length > 0) {
      clicklabels.forEach((clicklabel) => {
        // Ensure the ::before content isn't already added
          const text = clicklabel.textContent.trim();
          const priceMatch = text.match(/\$\s*\d+(\.\d{2})?/);
          const price = priceMatch[0];

          // Update the CSS variables dynamically
          clicklabel.style.setProperty('--price', `'${price}'`);
          console.log('Price updated:', price);
        
      });
  }
};

// Function to handle clicks on .product-form__input label
const handleLabelClick = (event) => {
  const label = event.currentTarget;
  console.log('Label clicked:', label);
  // delay for .1 second
  setTimeout(() => {
    updateLabelPrice(label);
  }, 10);
};

// Add event listener to .product-form__input labels
document.querySelectorAll('.product-form__input label').forEach((label) => {
  label.addEventListener('click', handleLabelClick);
});

// Check every second if the label exists
const intervalId = setInterval(checkAndAddPriceBefore, 1000);





  } catch(e) { console.error(e); }
})();
})();
